var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "LayoutWrapper",
    { attrs: { id: _vm.id } },
    [
      _c(
        "LayoutPaddingSpace",
        [
          _c(
            "LayoutColumn",
            [
              _c("SectionTitle", [
                _vm._v(
                  " " + _vm._s(_vm.$t("Search.labels.searchParameters")) + " "
                ),
              ]),
              _c(
                "SectionBlock",
                [
                  _c("SubjectLengthField"),
                  _c("SubjectCoverageField"),
                  _c("MaxTargetSequenceField", {
                    attrs: { "limit-options": _vm.limitOptions },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("ResetSection"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }